/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import {registerPlugin} from '@webex/webex-core';

import TeamMemberships from './team-memberships';

registerPlugin('teamMemberships', TeamMemberships);

export default TeamMemberships;
